import $ from 'jquery';

$(window).scroll(function (e) {
  if (e.currentTarget.pageYOffset >= 142) {
    $('header-fixed').css('display', 'block');
  } else {
    $('header-fixed').css('display', 'none');
  }

});